import _ from 'lodash';
import * as React from 'react';
import { DateFormat, Formatters } from '@Utils/Formats';
import { ITsViewFormat } from '@ModelViews/ModelViews';
import { isDefined } from '@Utils/Micro';
import { IconButton } from '@Primitive/Button';
// ------------------------------------------------------------------------------------------------
interface ILastUpdateTsProps {
    ts: string;
    explicitTs: boolean;
    dateFormat: DateFormat;
    viewFormat: ITsViewFormat;
}
// ------------------------------------------------------------------------------------------------
interface ILastUpdateTsState {
    ts: string;
}
// ------------------------------------------------------------------------------------------------
export const __LAST_UPDATE_TS_KEY__ = '__LAST_UPDATE_TS_KEY__';
// ------------------------------------------------------------------------------------------------
export class LastUpdateTs extends React.Component<ILastUpdateTsProps, ILastUpdateTsState> {
    // --------------------------------------------------------------------------------------------
    constructor(props: ILastUpdateTsProps) {
        super(props);
        // Initialize component's state.
        this.state = {
            ts: this.props.ts
        };
    }
    // --------------------------------------------------------------------------------------------
    componentDidUpdate(prevProps: ILastUpdateTsProps) {
        // New update?
        if (prevProps.ts != this.props.ts)
            this.setState({ ts: this.props.ts });
    }
    // --------------------------------------------------------------------------------------------
    render() {
        if (!isDefined(this.state.ts))
            return null;
        // Get formatted timestamp and size props.
        const ts = Formatters.datetime(
            this.state.ts,
            this.props.dateFormat
        );
        switch (this.props.viewFormat) {

            // Tooltip format?
            case ITsViewFormat.Tooltip:
                return <IconButton
                    tooltip={ts}
                    iconClassName="fas fa-history"
                    onClick={_.noop}
                    iconStyle={{
                        fontSize: 14,
                        color: "inherit"
                    }}
                />

            // Text format?
            case ITsViewFormat.Text:
                return <React.Fragment>
                    <span
                        ref={ref => {
                            if (ref != null) {
                                ref.style.display = null;
                                ref.style.maxWidth = null;
                                ref.style.whiteSpace = null;

                                // Find toolbar element.
                                let toolbar = ref.closest('.canvas-toolbar') as HTMLElement;
                                if (toolbar == null)
                                    return;

                                toolbar.onmouseenter = null;
                                toolbar.onmouseleave = null;
                                let initialWd: number;

                                // Find title element.
                                let el = toolbar.querySelector('#label-auto-size') as HTMLElement;
                                if (el == null)
                                    el = toolbar;
                                else {
                                    // Keep the initial width of title.
                                    initialWd = el.clientWidth;

                                    // Fit timestamp (if needs to).
                                    while (ref.clientHeight > el.clientHeight) {
                                        const prevWd = el.clientWidth;
                                        el.style.width = el.clientWidth - 1 + 'px';

                                        // Break out if there isn't more free space.
                                        if (el.clientWidth == prevWd)
                                            break;
                                    }
                                }

                                if (ref.clientHeight > el.clientHeight) {
                                    // Necessary styling about overflow.
                                    ref.style.maxWidth = ref.clientWidth + 'px';
                                    ref.style.whiteSpace = 'nowrap';
                                }

                                // Is there a text overflow?
                                if (ref.scrollWidth > ref.clientWidth || el.scrollWidth > el.clientWidth) {
                                    // Fallback to hover view format.
                                    ref.style.display = 'none';

                                    // Fallback to the initial width.
                                    if (_.isNumber(initialWd))
                                        el.style.width = initialWd + 'px';
                                }
                            }
                        }}
                        style={{
                            marginLeft: 10,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}>
                        {ts}
                    </span>
                </React.Fragment>;

            // Hover format?
            case ITsViewFormat.Hover:
            default:
                return null;
        }
    }
    // --------------------------------------------------------------------------------------------
}